var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_755_15362)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_755_15362)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#A68A2D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_755_15362)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.8525,
    cy: 15.0597,
    rx: 24.1463,
    ry: 23.7024,
    fill: "#F9DD80"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_755_15362)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.6326,
    cy: 11.7859,
    rx: 14.7561,
    ry: 14.4048,
    fill: "#FDE8A4"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter3_f_755_15362)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.2504,
    cy: 3.73998,
    rx: 6.2504,
    ry: 3.73998,
    transform: "matrix(0.981993 -0.188915 0.196258 0.980552 20.1208 37.7189)",
    fill: "#F3D161"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.56 10.76C23.56 10.76 25.1333 11.2 26.28 12.08C27.4533 12.96 28.04 14.2133 28.04 15.84C28.04 16.88 27.7733 17.8533 27.24 18.76C26.7333 19.64 26.0667 20.48 25.24 21.28C24.4133 22.0533 23.52 22.8133 22.56 23.56C21.6267 24.28 20.7067 24.9867 19.8 25.68C18.92 26.3733 18.16 27.08 17.52 27.8H26.04C27.1333 27.8 27.8267 27.6667 28.12 27.4C28.4133 27.1067 28.6133 26.6133 28.72 25.92H29.48C29.48 27.5733 29.4933 28.8533 29.52 29.76C29.5467 30.6667 29.5867 31.48 29.64 32.2C29.4 32.1467 28.96 32.1067 28.32 32.08C27.68 32.0533 26.9467 32.0267 26.12 32C25.2933 32 24.48 32 23.68 32H12.8V31.24C13.5733 30.44 14.5067 29.56 15.6 28.6C16.72 27.6133 17.8 26.5333 18.84 25.36C19.9067 24.1867 20.7867 22.9067 21.48 21.52C22.2 20.1333 22.56 18.6267 22.56 17C22.56 15.56 22.2267 14.5067 21.56 13.84C20.92 13.1733 19.9733 12.84 18.72 12.84C17.6267 12.84 16.6267 13.1333 15.72 13.72C14.84 14.28 14.0533 15.1067 13.36 16.2L12.72 15.76C13.2267 14.88 13.8533 14.0667 14.6 13.32C15.3733 12.5467 16.32 11.9333 17.44 11.48C18.5867 11 19.96 10.76 21.56 10.76Z",
    fill: "#826E2D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_755_15362",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.2771,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_755_15362"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.10839
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.905882 0 0 0 0 0.756863 0 0 0 0 0.266667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_755_15362"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_755_15362",
    x: -20.2575,
    y: -24.6064,
    width: 80.2202,
    height: 79.3322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.98186,
    result: "effect1_foregroundBlur_755_15362"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_755_15362",
    x: -14.0873,
    y: -18.5826,
    width: 61.4396,
    height: 60.7369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.98186,
    result: "effect1_foregroundBlur_755_15362"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_755_15362",
    x: 13.148,
    y: 28.689,
    width: 27.6895,
    height: 23.0326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.83129,
    result: "effect1_foregroundBlur_755_15362"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_755_15362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber2);
export default __webpack_public_path__ + "static/media/number2.c51d492fbb69dd8f826d26ddcb3c7edd.svg";
export { ForwardRef as ReactComponent };